// extracted by mini-css-extract-plugin
export var cubeNavigation = "cubeNavigation-module--cubeNavigation--181c3";
export var innerContainer = "cubeNavigation-module--innerContainer--8e847";
export var item = "cubeNavigation-module--item--b38f9";
export var itemsWrapper = "cubeNavigation-module--itemsWrapper--91ac1";
export var logo = "cubeNavigation-module--logo--7ee63";
export var menuText = "cubeNavigation-module--menuText--efe51";
export var secondaryColor = "cubeNavigation-module--secondaryColor--322c9";
export var selected = "cubeNavigation-module--selected--b79da";
export var subMenu = "cubeNavigation-module--subMenu--ed913";
export var subMenuLink = "cubeNavigation-module--subMenuLink--d90b3";
export var subMenuLinkText = "cubeNavigation-module--subMenuLinkText--5dbe1";